import { motion, Variants } from "framer-motion";
import styled from "styled-components";
import { ImageConfig } from "../../models/client";
import { fill } from "../../styles/utils";

interface ThreeSixtyImagesProps {
  images: ImageConfig[];
  currentIndex: number;
  onImageLoad: () => void;
}

const Image = styled(motion.img)`
  ${fill()}
  cursor: none;
  pointer-events: none;
`;

const imageVariants: Variants = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 },
};

export const ThreeSixtyImages: React.FC<ThreeSixtyImagesProps> = ({
  images,
  currentIndex,
  onImageLoad,
}) => {
  return (
    <>
      {images.map((image, i) => (
        <Image
          key={image.src}
          src={image.src}
          animate={i === currentIndex ? "visible" : "hidden"}
          variants={imageVariants}
          transition={{ duration: 0 }}
          onLoad={onImageLoad}
        ></Image>
      ))}
    </>
  );
};
